import { render, staticRenderFns } from "./widgetIframeYB.vue?vue&type=template&id=28664c97&scoped=true"
import script from "./widgetIframeYB.vue?vue&type=script&lang=js"
export * from "./widgetIframeYB.vue?vue&type=script&lang=js"
import style0 from "./widgetIframeYB.vue?vue&type=style&index=0&id=28664c97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28664c97",
  null
  
)

export default component.exports